module.exports = __webpack_public_path__ + "img/rep_icon.fcd2c911.svg";